var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 39,
    viewBox: "0 0 23 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4927 37.924L1.29162 20.774C1.08745 20.5698 0.943177 20.3486 0.858788 20.1104C0.773038 19.8722 0.730164 19.617 0.730164 19.3448C0.730164 19.0726 0.773038 18.8174 0.858788 18.5792C0.943177 18.341 1.08745 18.1198 1.29162 17.9156L18.4927 0.714583C18.9691 0.238194 19.5645 0 20.2791 0C20.9937 0 21.6062 0.255208 22.1166 0.765625C22.627 1.27604 22.8822 1.87153 22.8822 2.55208C22.8822 3.23264 22.627 3.82813 22.1166 4.33854L7.11037 19.3448L22.1166 34.351C22.593 34.8274 22.8312 35.4141 22.8312 36.111C22.8312 36.8092 22.576 37.4135 22.0656 37.924C21.5552 38.4344 20.9597 38.6896 20.2791 38.6896C19.5986 38.6896 19.0031 38.4344 18.4927 37.924Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.03b22c301dfdab133b13733f11e045d9.svg";
export { ForwardRef as ReactComponent };